import React from 'react';
import PropTypes from 'prop-types';

import PopupV2 from '../../../../Popup/PopupV2';
import styles from '../../collegeProspectTab.scss';

const TESTID_PREFIX = 'modal.remove-target-college';

const DeleteConfirmationModal = ({
    collegeName,
    isAlerted,
    errorMessage,
    isDeleting,
    onCancel,
    onConfirm,
}) => {
    return (
        <PopupV2
            onCloseClick={onCancel}
            config={{
                size: 'fullScreenOnMobile',
                customWidth: 420,
                customHeader: () => null,
                contentClassName: 'cpp-popup-card',
            }}
        >
            <div
                className={styles.deleteConfirmModal}
                data-testid={`${TESTID_PREFIX}.container`}
            >
                <div
                    className={styles.modalTitle}
                    data-testid={`${TESTID_PREFIX}.title`}
                >
                    Remove {collegeName} from your target list?
                </div>
                <div
                    className={styles.modalContent}
                    data-testid={`${TESTID_PREFIX}.body`}
                >
                    <p>
                        This college will be removed from your target list and you&apos;ll lose any history attached to it.
                    </p>
                    {isAlerted && (
                        <p data-testid={`${TESTID_PREFIX}.alerted-warning`}>
                            <strong>Alert College is on.</strong> Removing {collegeName} will take you out of their <em>Recruits That Like Me</em> list — coaches will no longer see you under this program.
                        </p>
                    )}
                    {errorMessage && (
                        <p
                            className={styles.modalError}
                            data-testid={`${TESTID_PREFIX}.error`}
                        >
                            {errorMessage}
                        </p>
                    )}
                </div>
                <div
                    className={styles.modalActions}
                    data-testid={`${TESTID_PREFIX}.actions`}
                >
                    <button
                        type="button"
                        className={styles.cppPopupButtonSecondary}
                        onClick={onCancel}
                        disabled={isDeleting}
                        data-testid={`${TESTID_PREFIX}.cancel-btn`}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className={styles.cppPopupButtonPrimary}
                        onClick={onConfirm}
                        disabled={isDeleting}
                        data-testid={`${TESTID_PREFIX}.confirm-btn`}
                    >
                        {isDeleting ? 'Removing…' : 'Remove'}
                    </button>
                </div>
            </div>
        </PopupV2>
    );
};

DeleteConfirmationModal.propTypes = {
    collegeName: PropTypes.string.isRequired,
    isAlerted: PropTypes.bool,
    errorMessage: PropTypes.string,
    isDeleting: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

DeleteConfirmationModal.defaultProps = {
    isAlerted: false,
    errorMessage: null,
    isDeleting: false,
};

export default DeleteConfirmationModal;
